import { render, staticRenderFns } from "./TimePeriodElement.vue?vue&type=template&id=6aad3236&scoped=true&"
import script from "./TimePeriodElement.vue?vue&type=script&lang=ts&"
export * from "./TimePeriodElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aad3236",
  null
  
)

export default component.exports